module.exports = __webpack_public_path__ + "img/guy.443cae3f.jpg";